import { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import "./AssignmentDetails.css"

const AssignmentDetails = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [assignment, setAssignment] = useState(null)

  useEffect(() => {
    // In a real app, this would fetch the assignment details from an API
    // For now, we'll use the same mock data
    const mockAssignment = {
      id: Number(id),
      title: "Light Spot Basic - Day 45 Reflection",
      description: "Write a 500-word reflection on how the teaching about faith has impacted your life.",
      dueDate: "2025-05-25",
      student: {
        id: 101,
        name: "John Smith",
        avatar: require('../../images/Untitled.jpeg'),
      },
      status: "pending",
      submissionDate: "2025-05-20",
      submission: {
        content: "The teaching about faith has deeply impacted my understanding of prayer. I've learned that faith is not just believing in God's existence, but trusting in His character and promises. This has transformed how I approach prayer, making it more meaningful and powerful.",
        attachments: [
          {
            name: "reflection_document.pdf",
            type: "pdf",
            size: "245KB"
          }
        ]
      }
    }
    setAssignment(mockAssignment)
  }, [id])

  if (!assignment) {
    return <div className="loading">Loading assignment details...</div>
  }

  return (
    <div className="assignment-details-page">
      <div className="details-header">
        <button className="btn btn-link" onClick={() => navigate(-1)}>
          <i className="material-icons">arrow_back</i>
          Back to Assignments
        </button>
        <h1>{assignment.title}</h1>
      </div>

      <div className="details-content">
        <div className="details-section">
          <h2>Assignment Information</h2>
          <div className="info-grid">
            <div className="info-item">
              <label>Status</label>
              <span className={`status-badge status-${assignment.status}`}>
                {assignment.status === "pending" ? "Pending Review" : 
                 assignment.status === "graded" ? "Graded" : 
                 "Not Submitted"}
              </span>
            </div>
            <div className="info-item">
              <label>Due Date</label>
              <span>{new Date(assignment.dueDate).toLocaleDateString()}</span>
            </div>
            <div className="info-item">
              <label>Submitted On</label>
              <span>{assignment.submissionDate ? new Date(assignment.submissionDate).toLocaleDateString() : "Not submitted yet"}</span>
            </div>
          </div>
        </div>

        <div className="details-section">
          <h2>Description</h2>
          <p className="description">{assignment.description}</p>
        </div>

        <div className="details-section">
          <h2>Student Information</h2>
          <div className="student-info">
            <img src={assignment.student.avatar} alt={assignment.student.name} className="student-avatar" />
            <div className="student-details">
              <h3>{assignment.student.name}</h3>
              <p>Student ID: {assignment.student.id}</p>
            </div>
          </div>
        </div>

        {assignment.submission && (
          <div className="details-section">
            <h2>Submission</h2>
            <div className="submission-content">
              <p>{assignment.submission.content}</p>
              
              {assignment.submission.attachments && assignment.submission.attachments.length > 0 && (
                <div className="attachments">
                  <h3>Attachments</h3>
                  <ul className="attachment-list">
                    {assignment.submission.attachments.map((attachment, index) => (
                      <li key={index} className="attachment-item">
                        <i className="material-icons">attachment</i>
                        <span>{attachment.name}</span>
                        <span className="file-size">({attachment.size})</span>
                        <button className="btn btn-sm">
                          <i className="material-icons">download</i>
                          Download
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}

        {assignment.status === "pending" && (
          <div className="details-section">
            <h2>Provide Feedback</h2>
            <form className="feedback-form">
              <div className="form-group">
                <label htmlFor="feedback">Feedback</label>
                <textarea
                  id="feedback"
                  className="form-control"
                  rows="4"
                  placeholder="Provide your feedback here..."
                ></textarea>
              </div>

              <div className="form-group">
                <label htmlFor="grade">Grade</label>
                <select id="grade" className="form-control">
                  <option value="">-- Select a grade --</option>
                  <option value="A">A - Excellent</option>
                  <option value="B">B - Good</option>
                  <option value="C">C - Satisfactory</option>
                  <option value="D">D - Needs Improvement</option>
                  <option value="F">F - Unsatisfactory</option>
                </select>
              </div>

              <div className="form-actions">
                <button type="submit" className="btn">
                  Submit Feedback
                </button>
              </div>
            </form>
          </div>
        )}

        {assignment.status === "graded" && (
          <div className="details-section">
            <h2>Feedback</h2>
            <div className="feedback-content">
              <div className="grade-display">
                <label>Grade:</label>
                <span className="grade">{assignment.grade}</span>
              </div>
              <div className="feedback-text">
                <label>Feedback:</label>
                <p>{assignment.feedback}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default AssignmentDetails 